import { Menu as AntdMenu } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
const Menu = props => {
  return /*#__PURE__*/_jsx(AntdMenu, {
    ...props
  });
};
Menu.Item = AntdMenu.Item;
Menu.SubMenu = AntdMenu.SubMenu;
Menu.Divider = AntdMenu.Divider;
Menu.ItemGroup = AntdMenu.ItemGroup;
export default Menu;